import { api } from './client';
import type { CharacterCondition, AddConditionRequest, UpdateConditionRequest } from '@charbuilder/shared';

export async function getConditions(characterId: string): Promise<CharacterCondition[]> {
  const { data } = await api.get(`/characters/${characterId}/conditions`);
  return data;
}

export async function addCondition(characterId: string, dto: AddConditionRequest): Promise<CharacterCondition> {
  const { data } = await api.post(`/characters/${characterId}/conditions`, dto);
  return data;
}

export async function updateCondition(
  characterId: string,
  conditionId: string,
  dto: UpdateConditionRequest,
): Promise<CharacterCondition> {
  const { data } = await api.patch(`/characters/${characterId}/conditions/${conditionId}`, dto);
  return data;
}

export async function deleteCondition(characterId: string, conditionId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/conditions/${conditionId}`);
}

export async function deleteAllConditions(characterId: string): Promise<void> {
  await api.delete(`/characters/${characterId}/conditions`);
}
